module.exports = __webpack_public_path__ + "static/media/network_network.81d97903.svg";